import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import styles from './OnePageStyleSoon.module.scss';

export const OnePageStyleSoon: FC = () => {
  return (
    <Box className={styles['menu-soon-wrapper']}>
      <Typography component="p" variant="subtitle1" className={styles['soon']}>
        Soon
      </Typography>
    </Box>
  );
};
